export default class OfferModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
